import type { NotificationType } from '../types';
import styles from './NotificationText.module.scss';

export default function NotificationText({
  type,
  text
}: {
  type: NotificationType;
  text: string;
}) {
  return (
    <div class={styles.notificationText}>
      <h4 class={styles.heading}>{type}</h4>
      <p>{text}</p>
    </div>
  );
}
